import { Field } from 'react-final-form';
import _ from 'lodash';
import { useState, useEffect } from 'react';
import { required, RequiredByFieldsList, ShowError } from './formUtils';
import RawInputOptionListForm from './RawInputOptionListForm';


const FormFieldMultiText = ({
  name,
  title,
  className,
  fieldsRequired = null
}) => {
  return (
    <div className={`pb-3 ${className}`}>
      <Field name={name}>
        {({ input, meta }) => (<div>
          <label position="floating">
            <span className={`font-semibold mr-3 ${meta.touched && meta.error ? 'text-red-600' : 'text-gray-900'}`}>
              {title}
              {meta.touched && meta.error ? '*' : ''}
            </span>
          </label>
          <RawInputOptionListForm 
            items={input.value || []} 
            onChange={(newItems) => {
              input.onChange(newItems);
            }} 
          />
          {/* Render error if any */}
          {meta.touched && meta.error && <div className="text-red-600" style={{ fontSize: 12 }}>{meta.error}</div>}
          {/* error */}
          <ShowError name={name} input={input} meta={meta} fieldsRequired={fieldsRequired} />
        </div>)}
      </Field>
    </div>
  );
};

export default FormFieldMultiText;